import {Component, OnInit} from '@angular/core';
import {NewBlank} from '../../../../models/new-blank.model';
import {Standard} from '../../../../models/standard.model';
import {AdminService} from '../../../../services/admin.service';

@Component({
  selector: 'app-opst-step-two',
  templateUrl: './opst-step-two.component.html',
  styleUrls: ['./opst-step-two.component.css']
})
export class OpstStepTwoComponent implements OnInit {
  isLoaded = false;
  formData: FormData = new FormData();
  newBlanks: NewBlank[] = [];
  standard: Standard;

  constructor(private adminService: AdminService) {
  }

  ngOnInit() {
    this.isLoaded = true;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-two/opst-step-two.component.ts